import * as types from './types';

const type = {
  GET: types.GET_USER_ACCOUNT,
  PUT: types.PUT_USER_ACCOUNT,
  PATCH: types.PATCH_USER_ACCOUNT,
  POST: types.POST_USER_ACCOUNT,
  DELETE: types.DELETE_USER_ACCOUNT
};

const apiRequest = ({ method = 'GET', path = '', body = {}, queryParams = {}, id = '' }) => ({
  type: type[method],
  meta: {
    async: true,
    api: 'users',
    path: `/v1/users/me/${path}${id}`,
    body,
    query: queryParams,
    method,
    section: path
  }
});

const resetUserAccount = ({ path = '' }) => ({
  type: types.RESET_USER_ACCOUNT,
  meta: {
    section: path
  }
});

export { apiRequest, resetUserAccount };
